import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../authentication/AuthProvider";
import { routes } from "../routes/routes";
import { findCurrectPermission } from "../helpers/roles-and-permissions";
import { enums } from "../enums/Enums";
export function  CandidateCVViewGuard ()  {
    let location = useLocation();
    const auth = useAuth();
  
    return auth?.user &&
      findCurrectPermission(enums.UserPermissionNames.HR_GetCandidateResume) ? (
      <Outlet />
    ) : (
      <Navigate
        to={routes?.unAuthorized.match}
        state={{ from: location }}
        replace
      />
    );
}

export function  CandidateCVmanageGuard ()  {
    let location = useLocation();
    const auth = useAuth();
  
    return auth?.user &&
      findCurrectPermission(enums.UserPermissionNames.HR_AddCandidateResume) ? (
      <Outlet />
    ) : (
      <Navigate
        to={routes?.unAuthorized.match}
        state={{ from: location }}
        replace
      />
    );
}
